import axios from 'axios'


export default() => {
  axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  axios.interceptors.request.use(config => {
    return config;
  }, error => {
    console.log('ERROR WITH AXIOS was sent');
    return Promise.reject(error);
  });
  return axios.create({
    baseURL: 'https://api.emika.ai/public_api',
    withCredentials: false,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    transformRequest: [function (data, headers) {
      let str = [];
      for(let p in data)
        if (data.hasOwnProperty(p) && data[p]) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
        }
      return str.join("&");
    }]
  })
}

// https://api.emika.ai/public_api
// http://localhost:8080/public_api
